'use client';

import { ToolsTranslations } from '@/lib/translations/types';

type Values = { averageCostPerShare: number; dividendPerShare: number };

interface Props {
  values: Values;
  onValuesChange: (field: keyof Values, value: number) => void;
  translations: ToolsTranslations['yieldOnCost'];
}

export default function CalculatorInputs({ values, onValuesChange, translations }: Props) {
  const parseNumber = (raw: string) => Number(raw.replace(/\s/g, '').replace(/,/g, '.'));
  const handleChange = (field: keyof Values) => (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = parseNumber(e.target.value);
    onValuesChange(field, isNaN(value) ? 0 : value);
  };

  const inputClass = "w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500";

  return (
    <div className="space-y-6">
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">{translations.averageCostPerShare}</label>
        <input type="text" value={`${values.averageCostPerShare.toLocaleString('sv-SE')} ${translations.currencySuffix}`}
               onChange={handleChange('averageCostPerShare')} className={inputClass} placeholder="0" />
      </div>
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">{translations.dividendPerShare}</label>
        <input type="text" value={`${values.dividendPerShare.toLocaleString('sv-SE')} ${translations.currencySuffix}`}
               onChange={handleChange('dividendPerShare')} className={inputClass} placeholder="0" />
      </div>
    </div>
  );
}


